import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function TTFPlantingTimeframeHeader() {
	return (
		<StickyHeader
			style={{ ...offsetOneRow, width: '290px', minWidth: '290px', maxWidth: '290px' }}>
			TTF planting timeframe
		</StickyHeader>
	)
}

export function TTFPlantingTimeframeFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.TTFPlantingTimeframeValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, TTFPlantingTimeframeValidated: e.value })
					}
				/>
				<TextFilter
					value={filter?.TTFPlantingTimeframe ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, TTFPlantingTimeframe: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function TTFPlantingTimeframeContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.TTFPlantingTimeframeValidated && <ValidatedIcon />}
				</span>
				<span>{ppn.PlantingProject.TTFPlantingTimeframe}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}